import React from "react";

/* Diagonal "opens a profile / leaves this view" arrow. */
export const ArrowUpRight = ({ width = 13, height = 12, className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 12"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M1.5 11L11.5 1M11.5 1H4M11.5 1V8.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowUpRight;
